<template>
    <b-img :src="url"></b-img>
</template>
<script>
export default {
    computed: {
        url() {
            if (!this.currentClient) return ''
            return this.currentClient?.pet_url ?? ''
        },
    },
}
</script>
